import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { MezzoTrasporto } from '../../../../../shared/interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-edit-mezzo-trasporto-accrediti-backoffice',
  templateUrl: './edit-mezzo-trasporto-accrediti-backoffice.component.html',
  styleUrl: './edit-mezzo-trasporto-accrediti-backoffice.component.css'
})
export class EditMezzoTrasportoAccreditiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService) {}
  
  @Input() visible: boolean = false;  
  @Input() mezzo_trasporto?: MezzoTrasporto;

  @Output() close = new EventEmitter<boolean>();

  tipologie: { tipologia: string }[] = [
    { tipologia: 'Furgone Piccolo' },
    { tipologia: 'Furgone Medio' },
    { tipologia: 'Motrice' },
    { tipologia: 'Bilico' },
  ];

  tipologie_filtrate: { tipologia: string }[] = [];

  loading: boolean = false;
  
  formMezzo!: FormGroup;

  ngOnInit(): void {
    this.formMezzo = new FormGroup({
      tipo: new FormControl(null, Validators.required),
      targa: new FormControl(null, Validators.required),
      azienda: new FormControl(null, Validators.required),
    });

    if (this.mezzo_trasporto) {
      this.formMezzo.patchValue({
        tipo: { tipologia: this.mezzo_trasporto?.tipologia },
        targa: this.mezzo_trasporto?.targa,
        azienda: this.mezzo_trasporto?.ditta
      })
    }
  }

  onFilterTipologie(event: AutoCompleteCompleteEvent) {
    this.tipologie_filtrate = [...this.tipologie].filter((tipo) => tipo.tipologia.toLowerCase().indexOf(event.query.toLowerCase()) == 0).length <= 0 ? [{ tipologia: event.query }] : [...this.tipologie].filter((tipo) => tipo.tipologia.toLowerCase().indexOf(event.query.toLowerCase()) == 0);
  }

  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
  }

  onEdit() {  
    
    let mezzo = {
      id_evento: (this.mezzo_trasporto?.id_evento || 0).toString(),
      tipologia: this.formMezzo.get('tipo')?.value ? this.formMezzo.get('tipo')?.value.tipologia : '',
      targa: this.formMezzo.get('targa')?.value || '',
      ditta: this.formMezzo.get('azienda')?.value || '',
    }  

    this.apiService.updateMezzoTrasporto(mezzo, this.mezzo_trasporto!.id).subscribe({
      next: (data) => this.apiService.setMezziTrasportoEvento(this.mezzo_trasporto!.id_evento),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        this.formMezzo.reset();
        this.formMezzo.markAsUntouched();
        this.formMezzo.markAsPristine();    

        this.onClose()
      }
    });

  }

}
